jQuery('#select-hallinnonala').change(function(){
    var term_id = jQuery(this).val();
    jQuery('#select-virasto option:gt(0)').remove();
    if(term_id){
        var children = hallinnonala_virasto[term_id]['children'];
        if(children){
            for(var key in children){
                var option = jQuery("<option></option>").attr('value', key).text(children[key]['name']).data('parent', term_id);
                jQuery('#select-virasto').append(option);
            }
            jQuery('#select-virasto').removeAttr('disabled');
        }else{
            jQuery('#select-virasto').attr('disabled', 'disabled');
        }
    }else{
        for(var parent_id in hallinnonala_virasto){
            var children = hallinnonala_virasto[parent_id]['children'];
            if(children){
                for(var key in children){
                    var option = jQuery("<option></option>").attr('value', key).text(children[key]['name']).data('parent', parent_id);
                    jQuery('#select-virasto').append(option);
                }
            }
        }
        jQuery('#select-virasto').removeAttr('disabled');
    }
});

var page = 0;
var form = jQuery('#mini-search-form').serialize();
var mini_search_enabled = true;

jQuery('#mini-search-form').submit(function(e){
    e.preventDefault();
    if(mini_search_enabled){
        mini_search_enabled = false;
        jQuery('#mini-search-submit .loading').show();
        form = jQuery(this).serialize();
        jQuery.ajax({
            type: 'POST',
            dataType: 'JSON',
            url: ajaxurl,
            data: {
                "action": "atoimeksianto_search",
                "form": form
            },
            success: function(data){
                console.log(data.results_left);
                page = 0;
                jQuery('#search-results').html(data.html);
                if(data.results_left > 0){
                    jQuery('#mini-search-load-more').show();
                }else{
                    jQuery('#mini-search-load-more').hide();
                }
                if(data.result_count > 0){
                    jQuery('#result-count-container').show();
                    jQuery('#result-count-number').text(data.result_count);
                }else{
                    jQuery('#result-count-container').hide();
                }
                mini_search_enabled = true;
                jQuery('#mini-search-submit .loading').hide();

                var navElement = jQuery('.search-page-sidebar');
		        var navOpened = navElement.hasClass('is-active');
                if(navOpened){
                    navElement.removeClass('is-active');
                    navElement.attr('aria-hidden', true);
                    navElement.attr('aria-expanded', false);
                    navElement.css('visibility', 'hidden');
                }
            }
        });
    }
    return false;
});
jQuery('#mini-search-load-more').click(function(){
    if(mini_search_enabled){
        mini_search_enabled = false;
        jQuery('#mini-search-load-more .loading').show();
        page = page + 1;
        jQuery.ajax({
            type: 'POST',
            dataType: 'JSON',
            url: ajaxurl,
            data: {
                "action": "atoimeksianto_search",
                "form": form,
                'page': page
            },
            success: function(data){
                console.log(data.results_left);
                if(data.results_left > 0){
                    jQuery('#mini-search-load-more').show();
                }else{
                    jQuery('#mini-search-load-more').hide();
                }
                jQuery('#search-results').append(data.html);
                mini_search_enabled = true;
                jQuery('#mini-search-load-more .loading').hide();
            }
        });
    }
    return false;
});